<nz-spin [nzSpinning]="isLoading">
    <div class="full-content">
        <div class="left-div">
            <div class="section-header">
                <i nz-icon nzType="file-text" nzTheme="outline"></i>
                <span>{{'Document' | translate}}</span>
            </div>
            <div *ngFor="let item of docFiles" class="content-item">
                <div class="item-content">
                    <i nz-icon nzType="file-pdf" nzTheme="outline"></i>
                    <span>{{item.fileName}}</span>
                </div>
                <nz-spin [nzSpinning]="isDownloading(item)">
                    <button nz-button class="download-btn" nzType="primary" nzGhost (click)="download(item)">
                        <i nz-icon nzType="download"></i>
                    </button>
                </nz-spin>
            </div>
        </div>
        <div class="right-div">
            <div class="section-header">
                <i nz-icon nzType="video-camera" nzTheme="outline"></i>
                <span>{{'Video' | translate}}</span>
            </div>
            <div *ngFor="let item of videoFiles" class="content-item">
                <div class="item-content">
                    <i nz-icon nzType="play-circle" nzTheme="outline"></i>
                    <span>{{item.fileName}}</span>
                </div>
                <nz-spin [nzSpinning]="isDownloading(item)">
                    <button nz-button class="download-btn" nzType="primary" nzGhost (click)="download(item)">
                        <i nz-icon nzType="download"></i>
                    </button>
                </nz-spin>
            </div>
        </div>
    </div>
</nz-spin>